import { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import { useModal } from 'src/utils/hooks';
import SiteBar from 'src/components/siteBar/siteBar';
import Footer from 'src/components/footer';
import Alert from 'src/typescript/components/alert/alert';
import Modal from 'src/modules/shared/modal/components/modalRoot';
import Head from 'src/utils/head';
import { updateLanguage, clearCurrentCommunity } from 'src/modules/shared/context/actions';
import classNames from 'classnames';
import VerificationBar from 'src/components/verificationBar';

import dynamic from 'next/dynamic';
const MarketingOptinModal = dynamic(() => import('src/modules/shared/modal/components/marketingOptinModal'), {ssr: false});
const ProfileSurveyModal = dynamic(() => import('src/modules/profileSurvey/components/profileSurveyModal'), {ssr: false});
const TakeProfileSurveyModal = dynamic(() => import('src/modules/profileSurvey/components/takeProfileSurveyModal'), {ssr: false});
const TakeProfileSurveyOnSignupModal = dynamic(() => import('src/modules/shared/modal/components/signup/profileSurveyOnSignup'), {ssr: false});

const DefaultLayout = (props) => {
    const {
      children,
      showVerificationBar,
      fullWidth,
      seo,
      siteContainerClassName,
      currentUser,
      updateLanguage,
      clearCurrentCommunity,
      currentCommunityExists,
    } = props;

    useEffect(() => {
      if (currentCommunityExists) {
        clearCurrentCommunity();
      }
    }, []);

    const pageContainerClassNames = classNames({
      'default-page-container': !fullWidth,
      'full-width-page-container': fullWidth,
      'content-top-margin': true,
    });

    return (
      <Fragment>
        <Head {...seo} extra={props.head} />
        <div className={siteContainerClassName}>
          <SiteBar />
          {currentUser && showVerificationBar && <VerificationBar />}
          <Alert />
          <main className={pageContainerClassNames} role="main">
            {children}
          </main>
          <Modal />
        </div>
        <Footer
          isLoggedIn={!!currentUser}
          updateLanguage={updateLanguage}
        />
        {useModal('MARKETING_OPT_IN', <MarketingOptinModal />)}
        {useModal('PROFILE_SURVEY', <ProfileSurveyModal />)}
        {useModal('TAKE_PROFILE_SURVEY_ON_SIGNUP', <TakeProfileSurveyOnSignupModal />)}
        {useModal('TAKE_PROFILE_SURVEY', <TakeProfileSurveyModal />)}
      </Fragment>
  );
};

DefaultLayout.defaultProps = {
  seo: undefined, // undefined otherwise seoDefaults is not used
  fullWidth: false,
};

export function mapStateToProps(state) {
  return {
    alert: state.alert.alert,
    currentUser: state.context.currentUser,
    currentCommunityExists: !!state.context.currentCommunity,
    isLoggedIn: !!state.context.currentUser,
    showVerificationBar: state.context.showVerificationBar,
  };
}

export default connect(mapStateToProps, { updateLanguage, clearCurrentCommunity })(DefaultLayout);
